import { all } from 'redux-saga/effects';
import AuthSagas from './AuthSagas';
import UserSagas from './UserSagas';
import DealerSagas from './DealerSagas';
import TicketSagas from './TicketSagas';
import NotificationSagas from './NotificationSagas';
import ReportSagas from './ReportSagas';

export default function* rootSaga(getState) {
  yield all([AuthSagas(), UserSagas(), DealerSagas(), TicketSagas(), NotificationSagas(), ReportSagas()]);
}
